import { useState, useEffect } from 'react';
import { Textarea, PillButtons, Label, Help } from '../../input';
import { Error } from '../../error';
import { TableFromObject } from '../../table';

export const TemplateInput = ({ params, onChange, errors }) => {
  const [templateStyle, setTemplateStyle] = useState('prompt');
  const [template, setTemplate] = useState();

  console.log('hhh template input got', params);

  useEffect(() => {
    console.log('lll ???', template, params.template);
    if (!template && params.template) {
      if (typeof params.template == 'string') {
        console.log('lll set template', params.template);
        setTemplateStyle('prompt');
        setTemplate(params.template);
      } else {
        console.log('lll set template SCHEMA', params.template);
        setTemplateStyle('schema');
        setTemplate(
          Object.entries(params.template)
            .map(([k, v]) => `${k} ${v}`)
            .join('\n'),
        );
      }
    }
  }, [params?.template]);

  useEffect(() => {
    if (!template) {
      return;
    }

    if (templateStyle == 'schema') {
      const t = {};
      for (const line of (template || '').split('\n')) {
        const m = line.trim().match(/([^ ]+) ?(.*)?/);
        if (!m) {
          continue;
        }
        const [name, description] = [m[1].trim(), (m[2] || '').trim()];
        t[name] = description;
      }
      console.log('lll ONCHANGE', t);
      onChange('template', t);
    } else {
      console.log('lll ONCHANGE 2', template);
      onChange('template', template);
    }
  }, [template, templateStyle]);

  const handleTemplate = (val) => {
    console.log('lll SET TEMPLATE', val);
    setTemplate(val);
  };

  const handleTemplateStyle = (val) => {
    setTemplateStyle(val);
  };

  const promptNode = (
    <div>
      <Help help="Describe the data you'd like to extract. The AI will figure out the schema." />
      <Textarea
        minRows={3}
        style={{ width: '100%', height: 120 }}
        value={template}
        onChange={(e) => handleTemplate(e.target.value)}
        placeholder={`name Name of the item on this page\nnumber Number of the item on this page`}
      />
      <Error small message={errors?.template} />
    </div>
  );

  const schemaNode = (
    <div>
      <Help help="Enter the data schema as one field per line. First word in the line is the field name, rest of the line is descrption." />
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 20 }}>
        <div style={{ width: '50%' }}>
          <Textarea
            minRows={3}
            style={{ width: '95%', height: 120 }}
            value={template}
            onChange={(e) => handleTemplate(e.target.value)}
            placeholder={`field_one Description of the first field\nfield_two Second field description`}
          />
        </div>
        <div style={{ width: '50%' }}>
          <TableFromObject obj={params.template} />
        </div>
      </div>
      <Error small message={errors?.template} />
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
        <Label label="Fields" />
        <PillButtons
          size="sm"
          value={templateStyle}
          onChange={handleTemplateStyle}
          choices={[
            ['prompt', 'Prompt'],
            ['schema', 'Schema'],
          ]}
        />
      </div>
      <div>
        {templateStyle == 'prompt' && promptNode}
        {templateStyle == 'schema' && schemaNode}
      </div>
    </div>
  );
};
